module.exports = __webpack_public_path__ + "img/gauge-dark.bf540753.svg";